import request from '@/sheep/request'

// 获取出行配置（距离阈值 + 费用）
export const getTravelConfig = () => {
	return request({
		url: '/wish/travel/config',
		method: 'GET'
	})
}

// 检查有效通行证
export const checkTravelPass = (placeId : string) => {
	return request({
		url: '/wish/travel/check',
		method: 'GET',
		params: { placeId }
	})
}

// 创建出行支付单
export const createTravelOrder = (data : { placeId : string, transportType : string }) => {
	return request({
		url: '/wish/travel/create-order',
		method: 'POST',
		data
	})
}

// 获取待出行通行证列表（已付费未使用）
export const getPendingTravelPasses = () => {
	return request({
		url: '/wish/travel/pending',
		method: 'GET'
	})
}

// 支付成功后更新通行证状态
export const handleTravelPaySuccess = (payOrderId : string) => {
	return request({
		url: '/wish/travel/handle-pay-success',
		method: 'POST',
		params: { payOrderId }
	})
}
